import React, { useEffect, useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

import "../../css/createSourceModal.css";
import {
    dynamicsConnectAut,
    sendDynamicsData,
} from "../../helpers/Sources/dynamics365/dynamics365";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const Dynamics365Source = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const [dynamicsInput, setDynamicsInput] = useState({
        dynamicsName: "",
        crmUrl: "",
    });
    const [connectData, setConnectData] = useState(null);
    const [dynamicsSourceID, setDynamicsSourceID] = useState("");
    const [dynamicsButtonDisabled, setDynamicsButtonDisabled] = useState(true);
    const [errorMessages, setErrorMessages] = useState({
        dynamicsName: "",
        crmUrl: "",
    });
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const language = useSelector((state) => state.languagesState.languages);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDynamicsInput({ ...dynamicsInput, [name]: value });
        setErrorMessages((prevErrors) => ({
            ...prevErrors,
            [name]: value.trim() === "" ? "Cannot be blank!" : "",
        }));
    };

    const sendDataDynamics = async (data) => {
        let newData = {
            code: data?.code,
        };
        let id = dynamicsSourceID;
        let response = await dynamicsConnectAut(newData, id);
        if (response?.status) {
            setConnectData(response?.data?.field_data?.fields);
            props?.setDynamicsStep && props?.setDynamicsStep(1);
            if (props.selectFileSourceId) {
                props.selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
    };

    const saveCrmMapping = (response) => {
        if (setIsLoadingButton !== undefined) {
            setIsLoadingButton(true);
        }
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            props?.handleClose(dynamicsSourceID);
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getTracker) {
                props.addToTracker(dynamicsSourceID);
            }
            props.getAllSourcesReduxProps && props.getAllSourcesReduxProps();

            setDynamicsSourceID("");
            if (setIsLoadingButton !== undefined) {
                setIsLoadingButton(false);
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (setIsLoadingButton !== undefined) {
                setIsLoadingButton(false);
            }
        }
    };

    useEffect(() => {
        if (dynamicsInput) {
            if (
                dynamicsInput?.dynamicsName === "" ||
                dynamicsInput?.dynamicsName === null ||
                dynamicsInput?.crmUrl === "" ||
                dynamicsInput?.crmUrl === null
            ) {
                setDynamicsButtonDisabled(true);
            } else {
                setDynamicsButtonDisabled(false);
            }
        }
    }, [dynamicsInput]);

    return (
        <div>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                {connectData ? (
                    <>
                        <CrmSourceMappingArea
                            sourceId={dynamicsSourceID}
                            sourceType={"dynamics"}
                            mappingSuccess={saveCrmMapping}
                            isModal={props?.isModal}
                            hideSaveButton={useHostFooter}
                            registerFooterAction={registerFooterAction}
                        />
                    </>
                ) : (
                    <>
                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages?.dynamicsName === null}
                        >
                            <TextField
                                name="dynamicsName"
                                label={language?.source_modal?.name ?? "Name"}
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.name ?? "Name"
                                }
                                value={dynamicsInput?.dynamicsName}
                                error={errorMessages?.dynamicsName === null}
                            />
                            {errorMessages?.dynamicsName && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.dynamicsName}
                                </div>
                            )}
                        </FormControl>

                        <FormControl
                            className="mb-3"
                            style={{ width: "100%" }}
                            error={errorMessages?.crmUrl === null}
                        >
                            <TextField
                                name="crmUrl"
                                label={
                                    language?.source_modal?.crm_url ?? "CRM URL"
                                }
                                variant="outlined"
                                onChange={handleInputChange}
                                placeholder={
                                    language?.source_modal?.crm_url ?? "CRM URL"
                                }
                                value={dynamicsInput?.crmUrl}
                                error={errorMessages?.crmUrl === null}
                            />
                            {errorMessages?.crmUrl && (
                                <div className="fileUploadStyle">
                                    {errorMessages?.crmUrl}
                                </div>
                            )}
                        </FormControl>

                        <LoginButton
                            code="dynamics"
                            getAuthUrl={sendDynamicsData}
                            getAuthUrlData={{
                                name: dynamicsInput?.dynamicsName,
                                usage_types: [4],
                                crm_url: dynamicsInput?.crmUrl,
                            }}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.url;
                            }}
                            onAuthUrlResponse={(response) =>
                                setDynamicsSourceID(response?.data?.source?.id)
                            }
                            onAuthUrlError={() => setIsLoadingButton(false)}
                            paramNames={["code"]}
                            onSuccess={sendDataDynamics}
                            dataTransform={(params) => ({ code: params.code })}
                            onLoadingChange={(loading) =>
                                setIsLoadingButton(loading)
                            }
                            logoSrc="/assets/images/dynamics-logo.png"
                            buttonText={
                                language?.buttons?.connect_with_dynamics ??
                                "Continue with Microsoft Dynamics 365"
                            }
                            disabled={dynamicsButtonDisabled}
                            isLoadingExternal={isLoadingButton}
                        />
                    </>
                )}
            </Form.Group>
        </div>
    );
};

export default Dynamics365Source;
